import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "relative" };
var _hoisted_2 = { class: "absolute px-[13px] py-[11px] bg-white bottom-[65px] shadow-[0px_1px_20px_rgba(0,0,0,0.05)] rounded-md left-1/2 transform -translate-x-1/2 flex flex-col items-center" };
import { ref, watch } from 'vue';
import dayjs from 'dayjs';
import ERecordAudio from '@common/ui/ERecordAudioController/components/ERecordAudio.vue';
import { RecordAudioStopByEnum } from '@common/ui/ERecordAudioController/enums/recordAudioStopBy.enum';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ERecordAudioController',
    props: {
        cancelDirection: {
            type: String,
            required: false
        },
        cancelDirectionDistance: {
            type: Number,
            required: false,
            default: 80,
        },
        hideTooltipAfterRetention: {
            type: Boolean,
            default: false,
        }
    },
    emits: {
        start: function (info) { },
        stop: function (audioChunks, stopBy, averageFrequency) { },
        send: function (audioChunks, averageFrequency) { },
        timer: function (timer) { },
        cancelPercentMove: function (movePercent) { },
        changeRetention: function (v) { }
    },
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emits = __emit;
        var intervalId = null;
        var startXY = ref([null, null]);
        var showTooltip = ref(false);
        var retention = ref(false);
        watch([showTooltip, retention], function (value) {
            if (value[0] && retention.value) {
                showTooltip.value = !props.hideTooltipAfterRetention;
            }
        });
        var recordAudioRef = ref();
        watch(retention, function (value) {
            emits('changeRetention', value);
        });
        var handleMove = function (mouseEvent) {
            audioRetention(mouseEvent);
            moveToCancelDirection(mouseEvent.clientX);
        };
        var audioRetention = function (mouseEvent) {
            if (startXY.value[1] && startXY.value[1] - mouseEvent.clientY >= 60) {
                retention.value = true;
            }
        };
        var moveToCancelDirection = function (clientX) {
            if (!props.cancelDirection || retention.value || !startXY.value[0]) {
                return;
            }
            var side = 1;
            if (['right'].includes(props.cancelDirection)) {
                side = -1;
            }
            var move = (startXY.value[0] - clientX) * side;
            var cancelOnePercent = props.cancelDirectionDistance / 100;
            var cancelPercent = move / cancelOnePercent;
            emits('cancelPercentMove', cancelPercent);
            if (move >= props.cancelDirectionDistance) {
                manualStop(RecordAudioStopByEnum.MOVE_TO_CANCEL, false, true);
            }
        };
        var handleStopAfterRetention = function () {
            manualStop(RecordAudioStopByEnum.TOOLTIP_CANCEL, true);
        };
        var handleStart = function (mouseEvent, audioDetails) {
            startXY.value = [mouseEvent.clientX, mouseEvent.clientY];
            showTooltip.value = true;
            intervalId = setInterval(function () { return countdown(audioDetails.date); }, 100);
            emits('start', audioDetails);
        };
        var handleStop = function (audioChunk, stopBy, averageFrequency) {
            showTooltip.value = false;
            stopCountdown();
            emits('stop', audioChunk, stopBy, averageFrequency);
        };
        var manualStop = function (by, retentionNew, clearedAudio) {
            var _a;
            if (retentionNew === void 0) { retentionNew = false; }
            if (clearedAudio === void 0) { clearedAudio = false; }
            (_a = recordAudioRef.value) === null || _a === void 0 ? void 0 : _a.manualStop(by, clearedAudio);
            showTooltip.value = false;
            stopCountdown();
            retention.value = retentionNew;
        };
        var countdown = function (startDate) {
            var start = dayjs(startDate);
            var now = dayjs(Date.now());
            var mmss = dayjs(now.diff(start)).format('mm:ss');
            var sss = (+dayjs(now.diff(start)).format('SSS') / 100).toFixed(0);
            emits('timer', "".concat(mmss, ",").concat(sss));
        };
        var stopCountdown = function () {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };
        var changeRetention = function (retentionNew) {
            retention.value = retentionNew;
        };
        var handleSend = function (audioChunk, averageFrequency) {
            stopCountdown();
            showTooltip.value = false;
            retention.value = false;
            emits('send', audioChunk, averageFrequency);
        };
        __expose({
            manualStop: manualStop,
            changeRetention: changeRetention
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_Transition, { name: "zoom-in-top" }, {
                    default: _withCtx(function () { return [
                        _withDirectives(_createElementVNode("div", _hoisted_2, [
                            (!retention.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_e_icon, {
                                        class: "h-5 w-4 text-[#4D576666] mb-6",
                                        icon: "lock-open"
                                    }),
                                    _createVNode(_component_e_icon, {
                                        class: "h-4 w-3 text-[#4D576666] rotate-180",
                                        icon: "arrow-down"
                                    })
                                ], 64))
                                : (retention.value && !__props.hideTooltipAfterRetention)
                                    ? (_openBlock(), _createBlock(_component_e_button, {
                                        key: 1,
                                        class: "w-4 h-4 bg-[#4D576666] rounded-[4px] hover:bg-gray-500 transition-all",
                                        size: "nosize",
                                        type: "text",
                                        onClick: handleStopAfterRetention
                                    }))
                                    : _createCommentVNode("", true)
                        ], 512), [
                            [_vShow, showTooltip.value]
                        ])
                    ]; }),
                    _: 1
                }),
                _createVNode(ERecordAudio, {
                    ref_key: "recordAudioRef",
                    ref: recordAudioRef,
                    retention: retention.value,
                    onMove: handleMove,
                    onSend: handleSend,
                    onStart: handleStart,
                    onStop: handleStop
                }, null, 8, ["retention"])
            ]));
        };
    }
});
